import { useScrollReveal } from "@/hooks/useScrollReveal";
import { lean } from "@/content";
import { Rich } from "@/lib/rich";

const painPoints = lean.pains.items;

export default function LeanPains() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section id="pains" className="py-24 relative overflow-hidden">
      <div className="absolute top-[0%] left-[30%] w-[350px] h-[350px] rounded-full bg-stone-200/40 blur-[120px] dark:bg-white/[0.04] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div
          ref={ref}
          className={`text-center mb-16 transition-all duration-700 ${
            revealed ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-red-50 border border-red-200 text-red-700 dark:bg-red-500/[0.12] dark:border-red-400/25 dark:text-red-300 text-xs font-semibold tracking-widest uppercase mb-6">
            {lean.pains.badge}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-stone-900 leading-tight mb-4 dark:text-white">
            <Rich text={lean.pains.title} accentClassName="text-stone-600 dark:text-white/55" />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {painPoints.map((pain, i) => (
            <PainCard key={i} pain={pain} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function PainCard({
  pain,
  index,
}: {
  pain: { icon: string; text: string };
  index: number;
}) {
  const { ref, revealed } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`group relative bg-white border border-stone-200 rounded-2xl p-6 md:p-8 hover:border-orange-300 dark:bg-white/[0.04] dark:border-white/[0.08] dark:hover:border-orange-500/40 hover:shadow-[0_8px_30px_rgba(234,88,12,0.06)] dark:hover:shadow-[0_8px_30px_rgba(249,115,22,0.06)] transition-all duration-500 ${
        revealed ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-stone-100 group-hover:bg-orange-50 dark:bg-white/[0.06] dark:group-hover:bg-orange-500/10 transition-colors mb-4">
        <i className={`${pain.icon} text-stone-600 group-hover:text-orange-600 text-xl dark:text-white/60 dark:group-hover:text-orange-400`}></i>
      </div>
      <p className="text-stone-700 text-sm leading-relaxed font-medium dark:text-white/70">
        «{pain.text}»
      </p>
    </div>
  );
}